function updatePriceDisplay() {
	const sellingPlanInput = document.querySelector('input.replace_selling_plan[name="selling_plan"]');

	if (sellingPlanInput) {
		const priceOneTime = document.querySelectorAll(".price-one-time");
		const priceSubscription = document.querySelectorAll(".price-subcription");

		if (sellingPlanInput.value) {
			priceOneTime.forEach(el => el.style.display = "none");
			priceSubscription.forEach(el => el.style.display = "inline-block");
			window.sellingPlanSelected = true;
		} else {
			priceOneTime.forEach(el => el.style.display = "inline-block");
			priceSubscription.forEach(el => el.style.display = "none");
			window.sellingPlanSelected = false;
		}

		updatePriceMain();
	}
}
window.updatePriceDisplay = updatePriceDisplay;

function updatePriceMain() {
	const qty_selected = document.querySelector('input[name="quantity-select"]:checked');
	const data = window.sellingPlanSelected ? JSON.parse(qty_selected?.getAttribute('data-subcription')) : JSON.parse(qty_selected?.getAttribute('data-one-time'));

	if (data) {
		const priceBlock = document.querySelector('.product-info .x-block-price');
		if (priceBlock) {
			priceBlock.querySelector('.main-product-price span.price-sale').innerText = data?.price;
			if (data?.priceOrigin) {
				priceBlock.querySelector('.main-product-price s.price-origin').innerText = data?.priceOrigin;
				priceBlock.querySelector('.main-product-price s.price-origin').classList.remove('hidden');
			} else {
				priceBlock.querySelector('.main-product-price s.price-origin').classList.add('hidden');
			}
			
			if (data?.discount) {
				priceBlock.querySelector('.main-product-price .price-discount').innerText = data?.discount;
				priceBlock.querySelector('.main-product-price .qb-saved-amount.discount').classList.remove('hidden');
			} else {
				priceBlock.querySelector('.main-product-price .qb-saved-amount.discount').classList.add('hidden');
			}
		}
	}
}
window.updatePriceMain = updatePriceMain;

window.addEventListener("load", function () {
	document.querySelector('.app-block .paywhirl-plan-selector')?.remove();
});